/** Normaliza readings de energia: chaves canônicas (current_*, average_current) ou legado (Influx + AVERAGE). */
export function normalizeEnergyReadingsForChart(readings: Record<string, Array<{ t?: string; v?: number }>>) {
  if (!readings || typeof readings !== 'object') {
    return { current_a: [], current_b: [], current_c: [], average: [] }
  }
  const keys = Object.keys(readings).filter((k) => Array.isArray(readings[k]) && (readings[k] as any[]).length > 0)
  if (keys.length === 0) return { current_a: [], current_b: [], current_c: [], average: [] }

  const hasCanonical =
    keys.includes('current_a') && keys.includes('current_b') && keys.includes('current_c')

  const averageKey = keys.find(
    (k) => k === 'average_current' || k === 'AVERAGE' || k.toUpperCase() === 'AVERAGE',
  )
  const seriesKeys = hasCanonical
    ? ['current_a', 'current_b', 'current_c', ...(averageKey ? [averageKey] : [])]
    : keys

  const byTime: Record<string, Record<string, number>> = {}
  seriesKeys.forEach((k) => {
    ;(readings[k] as Array<{ t?: string; v?: number }>).forEach((point) => {
      const t = point.t
      if (!t) return
      if (!byTime[t]) byTime[t] = {}
      const v = point.v
      if (typeof v === 'number' && !Number.isNaN(v)) byTime[t][k] = v
    })
  })

  const times = Object.keys(byTime).sort()
  const current_a: [number, number][] = []
  const current_b: [number, number][] = []
  const current_c: [number, number][] = []
  const average: [number, number][] = []

  times.forEach((t) => {
    const row = byTime[t]
    const ts = new Date(t).getTime()
    if (hasCanonical) {
      current_a.push([ts, row.current_a ?? null])
      current_b.push([ts, row.current_b ?? null])
      current_c.push([ts, row.current_c ?? null])
    } else {
      const currentKeys = seriesKeys.filter((k) => k !== averageKey)
      current_a.push([ts, row[currentKeys[0]] ?? null])
      current_b.push([ts, row[currentKeys[1]] ?? null])
      current_c.push([ts, row[currentKeys[2]] ?? null])
    }
    const avgVal = averageKey ? row[averageKey] : undefined
    const phaseVals = hasCanonical
      ? [row.current_a, row.current_b, row.current_c].filter((v) => v != null)
      : seriesKeys
          .filter((k) => k !== averageKey)
          .map((ck) => row[ck])
          .filter((v) => v != null)
    const avg =
      avgVal ??
      (phaseVals.length ? phaseVals.reduce((a: number, b: number) => a + b, 0) / phaseVals.length : null)
    average.push([ts, avg])
  })

  return { current_a, current_b, current_c, average }
}
